'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ButtonClear = require('../button/ButtonClear');

var _ButtonClear2 = _interopRequireDefault(_ButtonClear);

var _BaseCombobox2 = require('../combobox/BaseCombobox');

var _BaseCombobox3 = _interopRequireDefault(_BaseCombobox2);

var _ConfigGlobal = require('../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

var _IconComponent = require('../icon/IconComponent');

var _IconComponent2 = _interopRequireDefault(_IconComponent);

var _language = require('../language');

var _UtilApi = require('../utils/UtilApi');

require('antd/lib/select/style/css');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = (0, _component2.default)(function () {
  return import("antd/lib/select");
});

var IDCombobox = function (_BaseCombobox) {
  (0, _inherits3.default)(IDCombobox, _BaseCombobox);

  function IDCombobox(props) {
    (0, _classCallCheck3.default)(this, IDCombobox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDCombobox.__proto__ || (0, _getPrototypeOf2.default)(IDCombobox)).call(this, props));

    _this.convertValue = function (value) {
      var _this$props = _this.props,
          type = _this$props.type,
          isMulti = _this$props.isMulti;

      if (type === 'tag' && isMulti === false) {
        return value ? [value] : [];
      }
      return value;
    };

    _this.onDropdownVisibleChange = function (open) {
      if (open !== _this.state.open) {
        _this.setState({
          open: open
        });
      }
    };

    _this.handleChange = function (value) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          type = _this$props2.type,
          isMulti = _this$props2.isMulti,
          valueKey = _this$props2.valueKey;

      if (disabled || readOnly) {
        return;
      }
      var onChange = _this.props.onChange;

      var valueOption = null;
      if (!isMulti) {
        valueOption = _lodash2.default.find(_this.state.options, function (o) {
          return o[valueKey] == value;
        });
      } else {
        valueOption = _lodash2.default.filter(_this.state.options, function (o) {
          return value.indexOf(o[valueKey]) > -1;
        });
      }

      if (type === 'tag' && isMulti === false) {
        var newValue = null;
        var newValueOption = null;
        if (_lodash2.default.size(value) === 0) {
          newValue = null;
          newValueOption = null;
        } else {
          newValue = _lodash2.default.last(value);
          newValueOption = _lodash2.default.last(valueOption);
        }
        _this.setState({
          value: newValue ? [newValue] : []
        }, function () {
          onChange && onChange(newValue, newValueOption);
        });
      } else {
        _this.setState({
          value: value
        }, function () {
          onChange && onChange(value, valueOption);
        });
      }
    };

    _this.getTypeTag = function () {
      var _this$props3 = _this.props,
          mode = _this$props3.mode,
          type = _this$props3.type;

      return mode === "tags" || type == 'tag';
    };

    _this.getTypeMultiple = function () {
      var _this$props4 = _this.props,
          mode = _this$props4.mode,
          isMulti = _this$props4.isMulti;

      return mode == "multiple" || isMulti;
    };

    _this.getPopupContainer = function (trigger) {
      var _this$props5 = _this.props,
          popupContainer = _this$props5.popupContainer,
          popupContainerCls = _this$props5.popupContainerCls;

      if (!popupContainer) {
        return document.body;
      } else if (popupContainerCls) {
        return trigger.parentNode.closest('.' + popupContainerCls);
      }
      return trigger.parentNode.closest('.popup-container') || document.body;
    };

    _this.state = {
      value: (0, _UtilApi.getProxy)(props) ? "" : _this.convertValue(!_this.checkIsEmptyOrNull(props.value) ? props.value : props.defaultValue),
      options: (0, _UtilApi.getProxy)(props) ? [] : _this.convertData(props.options),
      open: false
    };
    _this.dataTestID = 'select';
    return _this;
  }

  (0, _createClass3.default)(IDCombobox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var proxy = (0, _UtilApi.getProxy)(this.props);
      if (proxy) {
        this.loadData(proxy, function (options) {
          _this2.setState({
            options: options,
            value: _this2.convertValue(!_this2.checkIsEmptyOrNull(_this2.props.value) ? _this2.props.value : _this2.props.defaultValue)
          });
        });
      }
    }
  }, {
    key: 'getMode',
    value: function getMode() {
      var _props = this.props,
          isMulti = _props.isMulti,
          mode = _props.mode,
          type = _props.type;

      if (mode === 'tags' || type === 'tag') {
        return 'tags';
      }

      if (isMulti === true || mode === 'multiple' || type === 'tag') {
        return 'multiple';
      }

      return null;
    }
  }, {
    key: 'getIsMulti',
    value: function getIsMulti() {
      var _props2 = this.props,
          isMulti = _props2.isMulti,
          mode = _props2.mode,
          type = _props2.type;

      if (isMulti === true || ['tags', 'multiple'].indexOf(mode) > -1 || type === 'tag') {
        return true;
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          options = _state.options,
          value = _state.value,
          open = _state.open;
      var _props3 = this.props,
          labelKey = _props3.labelKey,
          valueKey = _props3.valueKey,
          style = _props3.style,
          className = _props3.className,
          disabled = _props3.disabled,
          readOnly = _props3.readOnly,
          border = _props3.border,
          isClearable = _props3.isClearable,
          visibleIcon = _props3.visibleIcon,
          iconCls = _props3.iconCls,
          iconType = _props3.iconType,
          iconLine = _props3.iconLine,
          dropdownClassName = _props3.dropdownClassName,
          mode = _props3.mode,
          placeholder = _props3.placeholder,
          type = _props3.type,
          dropdownMatchSelectWidth = _props3.dropdownMatchSelectWidth,
          virtual = _props3.virtual,
          isMulti = _props3.isMulti;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('body-wrap', 'body-select', className, {
            'none-border': !border,
            'input-disabled': disabled,
            'read-only': readOnly,
            'none-icon': !visibleIcon,
            'visible-icon': visibleIcon,
            'input-auto-height': this.getIsMulti()
          }),
          style: style
        },
        _react2.default.createElement(
          Select,
          (0, _extends3.default)({}, _lodash2.default.omit(this.props, ['className', 'border', 'labelKey', 'valueKey', 'options', 'isMulti']), {
            ref: function ref(c) {
              return _this3.Select = c;
            },
            dropdownMatchSelectWidth: virtual ? true : dropdownMatchSelectWidth,
            value: value,
            mode: this.getMode(),
            'data-testid': this.getDataTestId(),
            onChange: this.handleChange,
            suffixIcon: !readOnly && visibleIcon ? _react2.default.createElement(_IconComponent2.default, {
              style: { height: '100%' },
              iconCls: (0, _classnames2.default)(iconCls, "ant-select-suffix"),
              iconType: iconType || (this.getIsMulti() ? 'plus-square' : _lodash2.default.get(_ConfigGlobal2.default, 'iconType.select', "caret-down")),
              iconLine: border === false ? false : iconLine
            }) : "",
            clearIcon: !readOnly && isClearable ? _react2.default.createElement(_ButtonClear2.default, { onClick: this.onClear }) : _react2.default.createElement('span', null),
            allowClear: isClearable,
            placeholder: _react2.default.createElement(_language.TextTranslate, { text: placeholder }),
            open: open,
            dropdownClassName: (0, _classnames2.default)(dropdownClassName, this.getSubDataTestId('picker')),
            onDropdownVisibleChange: this.onDropdownVisibleChange,
            getPopupContainer: this.getPopupContainer,
            filterOption: function filterOption(input, option) {
              if (_this3.props.filterOption) {
                return _this3.props.filterOption({ data: option, label: option.label }, input);
              }
              return _this3.boDauTiengViet(_lodash2.default.get(option, labelKey)).toLowerCase().includes(_this3.boDauTiengViet(input).toLowerCase());
            }
          }),
          _lodash2.default.isArray(options) && _lodash2.default.map(options, function (option, index) {
            return _react2.default.createElement(
              Select.Option,
              (0, _extends3.default)({}, option, {
                key: 'id-select-option-' + index,
                value: _lodash2.default.get(option, valueKey),
                label: _lodash2.default.get(option, labelKey)
              }),
              _react2.default.createElement(_language.TextTranslate, { text: _lodash2.default.get(option, labelKey) })
            );
          })
        ),
        this.getTypeMultiple() && _react2.default.createElement(
          'div',
          {
            style: {
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              zIndex: 'inherit'
            }
          },
          _react2.default.createElement(_IconComponent2.default, {
            style: { height: '100%' },
            iconCls: (0, _classnames2.default)(iconCls, "ant-select-suffix"),
            iconType: iconType || _lodash2.default.get(_ConfigGlobal2.default, 'iconType.select', "caret-down"),
            iconLine: border === false ? false : iconLine
          })
        )
      );
    }
  }]);
  return IDCombobox;
}(_BaseCombobox3.default);

exports.default = IDCombobox;


IDCombobox.defaultProps = (0, _assign2.default)({}, _BaseCombobox3.default.defaultProps, {
  border: true,
  placeholder: "Select...",
  isClearable: true,
  iconCls: "",
  iconType: "",
  dropdownMatchSelectWidth: false,
  visibleIcon: true,
  type: 'combobox',
  popupContainer: true,
  virtual: true,
  showSearch: true
});